'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('./_tslib-15827112.js');
var getScript = require('./getScript.js');
require('axios');
var LoginConsent = require('./LoginConsent.js');
var AuthApi = require('./AuthApi.js');

var Auth = /** @class */ (function () {
    function Auth(props) {
        var _this = this;
        this.sdkLoaded = false;
        this.LoadSdk = function (url) {
            if (_this.sdkLoaded)
                return Promise.resolve();
            _this.sdkLoaded = true;
            return getScript.default(url);
        };
        this._authCallback = function (data, type, isNewUser) { return _tslib.__awaiter(_this, void 0, void 0, function () {
            var _a, setCookie, sendEvent, StatsData, DaysCookieExpires;
            return _tslib.__generator(this, function (_b) {
                _a = this.props, setCookie = _a.setCookie, sendEvent = _a.sendEvent, StatsData = _a.StatsData;
                if (!data || !data.id)
                    return [2 /*return*/, Promise.resolve()];
                DaysCookieExpires = 90;
                setCookie('EndUserId', data.id, DaysCookieExpires * 24);
                setCookie('AccessToken', data.accessToken, DaysCookieExpires * 24);
                setCookie('ExpirationAccessToken', data.expiration, DaysCookieExpires * 24);
                if (isNewUser) {
                    this.$LoginConsent.sendConsentStat();
                }
                sendEvent('User/Login', data.id, type, StatsData.Platform);
                return [2 /*return*/, ({
                        isLogged: true
                    })];
            });
        }); };
        this.props = props;
        this.$LoginConsent = new LoginConsent.default(_tslib.__assign({}, props));
        this.$AuthApi = new AuthApi.default(this.props.AuthApiUrl);
    }
    return Auth;
}());

exports.default = Auth;
//# sourceMappingURL=Auth.js.map
